import React from 'react';
import { Nav } from 'react-bootstrap';
import useSections from '../hooks/useSections';

export default function GalleryNav({ activeKey }) {
  const { sections } = useSections();
  const enabledSections = sections.filter(s => s.enabled !== false && s.key !== 'images');

  return (
    <Nav variant="pills" className="box" defaultActiveKey={activeKey}>
      <Nav.Item key="gallery">
        <Nav.Link eventKey="gallery" href="gallery">الصور</Nav.Link>
      </Nav.Item>
      {enabledSections.map((s) => (
        <Nav.Item key={s.key}>
          <Nav.Link eventKey={s.key} href={s.key}>
            {s.label}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
}
